import { observer } from "mobx-react-lite";

import { useFormState } from "./form.state";
import { FormView } from "./form.view";

export const Form = observer(() => {
  const state = useFormState();
  return <FormView state={state} />;
});
